import React from 'react'

import { SnackbarProvider } from 'notistack'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  variantSuccess: {
    backgroundColor: `${theme.palette.successCard.main} !important`,
    color: `${theme.palette.successCard.contrastText} !important`
  },
  variantError: {
    backgroundColor: `${theme.palette.errorCard.main} !important`,
    color: `${theme.palette.errorCard.contrastText} !important`
  },
  variantInfo: {
    backgroundColor: `${theme.palette.infoCard.main} !important`,
    color: `${theme.palette.infoCard.contrastText} !important`
  },
  variantWarning: {
    backgroundColor: `${theme.palette.warningCard.main} !important`,
    color: `${theme.palette.warningCard.contrastText} !important`
  }
}))
interface CustomSnackbarProviderProps {
  children: any
}
const CustomSnackbarProvider: React.FC<CustomSnackbarProviderProps> = ({ children }) => {
  const classes = useStyles()

  return (
    <SnackbarProvider
      maxSnack={10}
      style={{ minWidth: 300 }}
      classes={{
        variantSuccess: classes.variantSuccess,
        variantError: classes.variantError,
        variantInfo: classes.variantInfo,
        variantWarning: classes.variantWarning
      }}
    >
      {children}
    </SnackbarProvider>
  )
}

export default CustomSnackbarProvider
